module.exports = __webpack_public_path__ + "img/pending-icon.faae6db7.svg";